import React, {useState} from "react";
import GaugeComponent from "react-gauge-component";
import { Box } from "@mui/material";

const GuageDisplay = ({ gaugeValue }) => {
  const [clientHeight] = useState(window.innerHeight);
  const kWToText = () => {
    return parseFloat(gaugeValue).toFixed(2) + " kW";
  };
  return (
    <>
      <Box
      sx={{
        mt: -2,
        width: clientHeight < 500 ? "50%" : "65%",
        height: clientHeight < 500 ? "20%" : "25%",
        mx: "auto",
      }}
    >
        <GaugeComponent
          value={gaugeValue}
          maxValue={5}
          minValue={0}
          type="radial"
          labels={{
            valueLabel: {
              fontSize: 40,
              formatTextValue: kWToText,
              style: {
                fill: "rgba(0, 0, 0, 0.87)",
                textShadow: "none",
                fontFamily: "Roboto",
              },
            },
            tickLabels: {
              type: "inner",
              ticks: [
                { value: 0, label: "0" },
                { value: 1, label: "1" },
                { value: 2, label: "2" },
                { value: 3, label: "3" },
                { value: 4, label: "4" },
                { value: 5, label: "5" },
              ],
            },
          }}
          arc={{
            colorArray: ["#5BE12C", "#EA4228"],
            gradient: true,
            subArcs: [
              { limit: 1 },
              { limit: 2 },
              { limit: 3 },
              { limit: 4 },
              { limit: 5 },
            ],
            padding: 0,
            width: 0.2,
            cornerRadius: 0,
          }}
          pointer={{ elastic: true, animationDelay: 0 }}
        />
      </Box>
    </>
  );
};

export default GuageDisplay;
